import { Box, Tag } from '@factorialco/deprecated-design-system'

interface Props {
  itemsName: string[]
}

export const ItemsTags = ({ itemsName }: Props) => {
  if (itemsName.length === 0) return <Tag inline>{'-'}</Tag>

  const slicedItems = itemsName.slice(0, 2)

  const extraItems = itemsName.length - slicedItems.length

  return (
    <Box gap="s4" flexDirection="row" flexWrap="wrap">
      {slicedItems.map((item, index) => (
        <Tag key={index}>{item}</Tag>
      ))}
      {extraItems > 0 && <Tag key={slicedItems.length}>+ {extraItems}</Tag>}
    </Box>
  )
}
